import { Monitor, Moon, Sun } from 'lucide-react';
import { type ThemeMode, THEME_LABELS, useTheme } from '#client/providers/ThemeProvider';
import { Segmented } from './Segmented';

/**
 * Light / System / Dark.
 *
 * Three-way rather than a two-state switch, because "follow the OS" is a real
 * preference and collapsing it into a binary means the app stops tracking the
 * system when it gets dark in the evening.
 *
 * System sits in the middle so the two explicit choices flank it in the order
 * people expect (lightest to darkest).
 */
const OPTIONS: { value: ThemeMode; label: string; icon: React.ReactNode }[] = [
  { value: 'light', label: THEME_LABELS.light, icon: <Sun /> },
  { value: 'system', label: THEME_LABELS.system, icon: <Monitor /> },
  { value: 'dark', label: THEME_LABELS.dark, icon: <Moon /> },
];

export function ThemeToggle() {
  const { mode, setMode } = useTheme();

  return (
    <Segmented label="Colour theme" options={OPTIONS} value={mode} onChange={setMode} iconOnly />
  );
}
